import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import { Sidebar } from "_molecules";

const NewScreen = (props) => {
  return (
    <div fluid={true} style={{ display: "flex" }}>
      {props.sidebar == false ? (
        ""
      ) : (
        <div>
          <Sidebar />
        </div>
      )}
      <Container className="mt-3" style={props?.style}>
        {props.children}
      </Container>
    </div>
  );
};

export default NewScreen;
